<template>
  <div class="content getMoney">
    <div class="bodycontent"
      v-loading="IsLoading"
      :element-loading-text="LoadingText"
    >
      <div class="money-con">
        <div class="money-list">
          <SideList ref="side"></SideList>
        </div>
        <!--充值-->
        <div class="money-main">
          <div class="money-center">
            <div>
              <el-card class="box-card">
                <el-input
                  placeholder="搜索"
                  v-model="search_con"
                  clearable
                  @keyup.enter.native="getUserInfo"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getUserInfo"
                  ></el-button>
                </el-input>
                <div class="screenCont" v-if="show_user_infor">
                  <template v-if="user_infor">
                    <div class="vip-card-number">
                      <span>卡号: {{ user_infor.card_num }}</span>
                    </div>
                    <div class="vip-info">
                      <span class="vip-info-item">
                        姓名:
                        <span>{{ user_infor.real_name }}</span>
                      </span>
                      <span class="vip-info-item">
                        手机号:
                        <span>{{ user_infor.mobile }}</span>
                      </span>
                      <span class="vip-info-item">
                        会员等级:
                        <span>{{ user_infor.card_level }}</span>
                      </span>
                      <span class="vip-info-item">
                        余额:
                        <span @click="showUserAccountList(1)">{{
                          user_infor.balance
                        }}</span>
                      </span>
                      <span class="vip-info-item">
                        积分数量:
                        <span @click="showUserAccountList(2)">
                          {{ user_infor.point }}
                        </span>
                      </span>
                    </div>
                  </template>
                  <div v-else class="noUser">
                    <span>用户暂无开卡</span>
                    <el-button type="primary" size="mini" @click="oneOpenCard"
                      >立即开卡</el-button
                    >
                  </div>
                </div>
              </el-card>
              <el-card class="box-card" v-if="choseStatus == 'a'">
                <div class="pay-money">
                  <div class="pay-money-left">
                    <span>充值金额</span>
                    <el-input
                      ref="inputPrice"
                      maxlength="6"
                      :autofocus="true"
                      max="10"
                      v-model="inputPrice"
                      @focus="focusPrice(1)"
                      oninput="value=value.replace(/[^\-?\d.]/g,'')"
                      placeholder="输入充值金额"
                    ></el-input>
                  </div>
                  <div class="pay-money-right">
                    <span>赠送金额</span>
                    <el-input
                      ref="sendMoney"
                      maxlength="6"
                      :autofocus="true"
                      max="10"
                      v-model="send_money"
                      @focus="focusPrice(2)"
                      oninput="value=value.replace(/[^\-?\d.]/g,'')"
                      placeholder="输入充值金额"
                    ></el-input>
                  </div>
                </div>
              </el-card>
            </div>
            <div class="money-center-num">
              <KeyNumber
                class="key-number"
                ref="key_number"
                :money="sendNumber"
                @focusMethods="focusMethods"
              ></KeyNumber>
              <div class="key-right">
                <div
                  v-for="(item, index) in shortcutPrice"
                  :key="index"
                  class="key-right-item"
                  @click="selectPrice(item)"
                >
                  ￥{{ item }}
                </div>
              </div>
            </div>
          </div>
          <rechangePay
            ref="moneyPay"
            :user_infor="user_infor"
            :inputPrice="inputPrice"
            :integralNum="integralNum"
            :send_money="send_money"
            :recharge_info="recharge_info"
            :rechangeData="rechangeData"
            :parentOptionId="parentOptionId"
            @payEnd="getUserInfo"
            @sonChose="sonChose"
          ></rechangePay>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showUserAccount"
      :title="showAccountTitle"
      @close="closeAccount"
      width="600px"
    >
      <el-table
        :data="accountData"
        v-if="showAccountTitle == '余额变动记录'"
        size="medium"
        border
        v-loading="accountLoading"
        element-loading-text="正在查询..."
      >
        <el-table-column label="变动金额" prop="show_amount"></el-table-column>
        <el-table-column label="变动时间" prop="create_time"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column
          label="操作员手机号"
          prop="operate.mobile"
        ></el-table-column>
      </el-table>
      <el-table
        :data="accountData"
        v-if="showAccountTitle == '积分变动记录'"
        size="medium"
        border
        v-loading="accountLoading"
        element-loading-text="正在查询..."
      >
        <el-table-column label="变动金额" prop="show_amount"></el-table-column>
        <el-table-column label="变动原因" prop="show_style"></el-table-column>
        <el-table-column label="变动时间" prop="create_time"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column
          label="操作员手机号"
          prop="operate.mobile"
        ></el-table-column>
      </el-table>
      <div class="pagination" style="margin-top:10px">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="accountPage"
          :total="accountTotal"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getOilCardsDetail,searchCardIc } from "@/api/ic";
import { storeList } from "@/api/storeManage";
import rechangePay from "./rechangePay";
import { getRechargeInfo } from "@/api/user";
import { getBalanceLog, oneOpenCard, vipUserinfo } from "@/api/vip";
import SideList from "./recharge_side";
import KeyNumber from "@/components/public/KeyNumber";
import { mapGetters } from "vuex";
import { hideLoading, showLoading } from "@/utils/loading";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    SideList,
    KeyNumber,
    rechangePay,
  },
  data() {
    return {
      IsLoading:false,
      LoadingText:'加载中...',
      allRechangeAccount: "",
      room_id: "",
      integralNum: 0, // 积分数量够
      inputPrice: "", // 输入金额
      drawer: false,
      send_money: "", // 赠送金额
      search_con: "", // 搜索内容
      user_infor: "", // 查询用户信息
      fuel_charge: 0, // 加油量
      show_user_infor: false,
      shortcutPrice: ["100", "200", "500", "1000"],
      showUserAccount: false, // 显示用户余额/积分记录
      showAccountTitle: "余额变动记录",
      accountData: [], // 余额/积分记录
      accountPage: 1, // 记录页码
      accountTotal: 0, // 记录总数
      recharge_info: {}, // 充值项
      styleList: [
        { id: 0, name: "签到送积分" },
        { id: 1, name: "线下买单" },
        { id: 2, name: "充值" },
        { id: 3, name: "后台变动" },
        { id: 4, name: "回退" },
        { id: 5, name: "其他" },
        { id: 6, name: "积分兑换" },
        { id: 7, name: "邀请新人" },
      ],
      sendNumber: "",
      focusType: 0, //
      accountLoading: false,
      rechangeData: "",
      parentOptionId: "",
      choseStatus: "a",
      userCardInfo: {
        uid: "",
        oil_card: [],
        team_card: [],
      },
    };
  },
  watch: {
    inputPrice(val) {
      if (val.indexOf(".") > -1) {
        if (val.indexOf(".") == 0) {
          this.inputPrice = "0.";
        } else {
          this.inputPrice = val.substring(0, val.indexOf(".") + 3);
        }
      }
      // this.$refs.key_number.money = val;
    },
    search_con(val){
      if(!val){
        this.show_user_infor = false
        this.$refs.side.setCard([]);
      }
    },
  },
  mounted() {
    this.getShopList();
  },
  methods: {
    sonChose(val) {
      this.choseStatus = val;
    },
    // 获取焦点
    focusPrice(type) {
      this.sendNumber = "";
      if (type == 1) {
        this.sendNumber = this.inputPrice;
      } else if (type == 2) {
        this.sendNumber = this.send_money;
      }
      this.focusType = type;
    },
    focusMethods(val) {
      if (this.focusType == 1) {
        this.inputPrice = "";
        this.inputPrice = val;
        this.$refs.inputPrice.select();
      } else if (this.focusType == 2) {
        this.send_money = "";
        this.send_money = val;
        this.$refs.sendMoney.select();
      }
    },
    // 获取用户数据
    getUserInfo() {
      showLoading();
      if (this.search_con.length === 11) {
        var data = {
          app_id: this.app_id,
          mobile: this.search_con,
        };
        this.show_user_infor = true;
        vipUserinfo(data).then((res) => {
          if (res.code == 200) {
            this.user_infor = res.data;
            this.getCardList(this.user_infor.mobile);
            hideLoading();
          } else {
            this.user_infor = "";
            this.$refs.side.setCard([]);
            this.$message(res.msg);
            hideLoading();
          }
        });
      } else {
        var data = {
          token: this.token,
          app_id: this.app_id,
          card_num: this.search_con,
        };
        searchCardIc(data).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.user_infor = res.data.result[0];
            this.show_user_infor = true
            this.getCardList(this.user_infor.mobile);
            hideLoading();
          } else {
            hideLoading();
            this.show_user_infor = false
            this.search_con = "";
            this.user_infor = "";
            this.$refs.side.setCard([]);
            this.$message.error(res.msg);
          }
        });
      }
    },
    getCardList(phone) {
      let data = { token: this.token, app_id: this.app_id, mobile: phone };
      getRechargeInfo(data).then((res) => {
        if (res.code === 200) {
          // 获取用户油卡列表
          let { oil_card, team_card } = res.data;
          if (oil_card.length > 0)
            oil_card.map(
              (item) => ((item.card_type = 1), (item.account_type = 1))
            );
          if (team_card.length > 0)
            team_card.map(
              (item) => ((item.card_type = 3), (item.account_type = 2))
            );
          let arr = oil_card.concat(team_card);
          let obj = {
            id: res.data.card_id,
            type_id: res.data.card_id,
            type_name: "会员卡",
            balance: res.data.balance,
            card_type: 0, //充值选项
            account_type: 0,
          };
          arr.push(obj);
          this.$refs.side.setCard(arr);
          this.userCardInfo = res.data;
          hideLoading();
        } else {
          this.$message(res.msg);
          hideLoading();
        }
      });
    },
    getShopList() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: 1,
        name: "",
      };
      storeList(data).then((res) => {
        if (res.code == 200) {
          this.room_id = res.data[0].id;
        } else if (res.code == 400) {
          this.$message(res.msg);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    recount(val) {
      try {
        if (!val) return;
        this.recharge_info = val;
        let data = {
          app_id: this.app_id,
          token: this.token,
          card_id: val.type_id,
          card_type: val.card_type,
          uid: this.userCardInfo.uid,
        };
        getOilCardsDetail(data).then((res) => {
          if (res.code == 200) {
            this.rechangeData = res.data;
            // 每升减，锁油价
            this.rechangeData.rule.forEach((item) => {
              if (Number(item.is_unify) == 1) {
                // 每升减
                item.newUnify = [];
                // let cardData
                let cardIndex = item.liter_good_money.findIndex(
                  (son) => son.id == val.type_card_id
                );
                item.newUnify = item.liter_good_money[cardIndex].itemArr;
                console.log("cardIndex", cardIndex);
              }
              if (Number(item.is_lock) == "1") {
                // 每升减
                item.newLock = [];
                // let cardData
                let cardIndex = item.lock_good_money.findIndex(
                  (son) => son.id == val.type_card_id
                );
                item.newLock = item.lock_good_money[cardIndex].itemArr;
                console.log("cardIndex", cardIndex);
              }
            });
            this.parentOptionId = val.type_card_id;
          } else {
            this.rechangeData = "";
            this.$message.warning(res.msg);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 一键开卡
    oneOpenCard() {
      console.log(1212);
      var data = {
        token: this.token,
        app_id: this.app_id,
        mobile: this.search_con,
      };
      oneOpenCard(data).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getUserInfo();
        } else {
          this.$message(res.msg);
        }
      });
    },
    selectPrice(item) {
      this.inputPrice = item;
      // this.$refs.key_number.money = item;
    },
    // 显示用户账户 1.余额记录 2.积分记录
    showUserAccountList(i) {
      if (i == 1) {
        this.showAccountTitle = "余额变动记录";
      } else {
        this.showAccountTitle = "积分变动记录";
      }
      this.showUserAccount = true;
      this.getAccountData();
    },
    getAccountData() {
      this.accountLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.accountPage,
        mobile: this.user_infor.mobile,
      };
      if (this.showAccountTitle == "余额变动记录") {
        getBalanceLog(data).then((res) => {
          this.accountLoading = false;
          if (res.code == 200) {
            this.accountData = res.data;
            this.accountTotal = res.total;
            this.accountData.forEach((item) => {
              item.show_amount =
                item.type == 1
                  ? "+" + item.amount
                  : item.type == 2
                  ? "-" + item.amount
                  : item.amount;
            });
          }
        });
      } else {
        getPointLog(data).then((res) => {
          this.accountLoading = false;
          if (res.code == 200) {
            this.accountData = res.data;
            this.accountTotal = res.total;
            this.accountData.forEach((item) => {
              item.show_style = this.styleList.find(
                (x) => x.id == item.style
              ).name;
              item.show_amount =
                item.type == 1
                  ? "+" + item.num
                  : item.type == 2
                  ? "-" + item.num
                  : item.num;
            });
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.accountPage = val;
      this.getAccountData();
    },
    closeAccount() {
      this.showUserAccount = false;
      this.accountData = [];
      this.accountTotal = 0;
      this.accountPage = 1;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../sub_com";
.content {
  width: 100%;
  .bodycontent {
    min-width: 1200px;
    background: transparent;
    padding: 0px 0px 0;
  }
  .screenCont {
    display: flex;
    flex-direction: column;
    .noUser {
      display: flex;
      // justify-content: center;
      align-items: center;
      margin-top: 15px;

      .el-button {
        margin-left: 20px;
      }
    }
  }
}
.key-number {
  width: 80%;
}
</style>
<style lang="scss">
.getMoney {
  .bodycontent {
    background: transparent;
    padding: 0px 27px 10px;
  }
  .money-title {
    height: 60px;
    width: 100%;
    line-height: 60px;
    font-size: 16px;
    font-weight: 500;
    color: #696969;
  }
  .money-con {
    height: 100%;
    display: flex;
    overflow: hidden;
    padding: 10px;
    background: #fff;
    .pay_infor {
      .el-card__body {
        padding: 10px 15px;
      }
      .el-input {
        .el-input__inner {
          border: 0;
        }
      }
    }
    .submitAccounts {
      .el-card__body {
        padding: 0;
      }
    }
    .money-list {
      width: 350px;
      padding: 0 10px;
      margin-right: 10px;
      background: #fff;
    }
    .money-main {
      flex: 1;
      display: flex;
      padding: 10px;
      background: #f1f1f1;
      justify-content: space-between;
      .money-center {
        width: 60%;
        display: flex;
        position: relative;
        flex-direction: column;
        // padding-bottom: 10px;
        justify-content: space-between;
        .box-card {
          margin-bottom: 10px;
          .el-card__body {
            padding: 10px 15px;
          }
          .pay-money {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .pay-money-left {
              width: 50%;
              height: 50px;
              display: flex;
              align-items: center;
              border-right: 1px solid #dfdfdf;
              .el-input {
                flex: 1;
                text-align: right;
                .el-input__inner {
                  border: 0;
                  text-align: right;
                  color: #f56c6c;
                  font-size: 30px;
                }
                input::-webkit-input-placeholder {
                  font-size: 18px;
                }
                input::-moz-input-placeholder {
                  font-size: 18px;
                }
                input::-ms-input-placeholder {
                  font-size: 18px;
                }
              }
            }
            .pay-money-right {
              flex: 1;
              display: flex;
              padding: 0 20px;
              align-items: center;
              justify-content: center;
              span:nth-child(2) {
                color: orange;
                margin-left: 10px;
              }
              .el-input {
                flex: 1;
                text-align: right;
                .el-input__inner {
                  border: 0;
                  text-align: right;
                  color: #f56c6c;
                  font-size: 30px;
                }
                input::-webkit-input-placeholder {
                  font-size: 18px;
                }
                input::-moz-input-placeholder {
                  font-size: 18px;
                }
                input::-ms-input-placeholder {
                  font-size: 18px;
                }
              }
            }
          }
          .oilinfor {
            display: flex;
            justify-content: space-between;
            height: 30px;
            line-height: 30px;
            font-size: 18px;

            .oilinfor-name {
              color: #999;

              .oil {
                color: #e6a23c;
              }
            }
          }
          .weight {
            font-size: 18px;
            height: 30px;
            line-height: 30px;
            color: #999;
          }
        }

        .money-center-num {
          width: 100%;
          // height: 340px;
          display: flex;
          justify-content: space-between;
          position: relative;

          .key-right {
            flex: 1;
            margin-top: -11px;
            padding-top: 6px;
            margin-left: 5px;
            .key-right-item {
              width: 100%;
              height: 80px;
              border-radius: 6px;
              text-align: center;
              line-height: 80px;
              font-size: 16px;
              color: #f1f1f1;
              margin-top: 10px;
              cursor: pointer;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              background: #409eff;
              user-select: none;
            }
          }
        }
        .vip-card-number {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
        }
        .vip-info {
          .vip-info-item {
            margin-right: 10px;
            span {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>
